// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$String from "../../../../../../../node_modules/rescript/lib/es6/string.js";
import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function fromString(suspend_status) {
  var match = $$String.lowercase_ascii(suspend_status);
  switch (match) {
    case "not_suspended" :
        return /* NotSuspended */1;
    case "suspended" :
        return /* Suspended */0;
    default:
      return ErrorUtils$Catalyst.raiseError("SuspensionStatus.re", "Invalid 'suspend status' ", suspend_status);
  }
}

function toString(suspend_status) {
  if (suspend_status) {
    return "Not Suspended";
  } else {
    return "Suspended";
  }
}

export {
  fromString ,
  toString ,
  
}
/* No side effect */
